export default __webpack_public_path__ + "static/media/customer-journey-mapping.f1cdbeee.svg";